import React from "react";

export default function MetricCard({
  label,
  value,
  background,
  width = 220,
  labelFontSize = "1rem", // default ~fs-5
  valueFontSize = "2rem", // default ~fs-2
  textColor = "#000", // default black
}) {
  return (
    <div className="metric_card">
      <div
        className="rounded-2"
        style={{
          backgroundColor: background,
          border: "unset",
          width: width,
          color: textColor,
        }}
      >
        <div className="metric_card_body">
          <h6
            className="fw-semibold"
            style={{
              textAlign: "left",
              fontSize: labelFontSize,
              color: textColor,
            }}
          >
            {label}
          </h6>
          <h4
            className="fw-semibold"
            style={{
              textAlign: "left",
              margin: 0,
              fontSize: valueFontSize,
              color: textColor,
            }}
          >
            {value}
          </h4>
        </div>
      </div>
    </div>
  );
}
